import clsx from 'clsx';
import { View } from './view';
import { Select } from '@shared/widgets';

interface CardHolderSelectProps {
  className?: string;
  value: any;
  values: any;
  onChange: (value: any) => void;
}

export const CardHolderSelect = (props: CardHolderSelectProps) => {
  const handleChange = (value: any) => {
    if (value !== props.value) props.onChange(value);
  };

  return props.values.length > 1 ? (
    <Select
      className={clsx('border-none', props.className)}
      // @ts-ignore
      view={View}
      item={View}
      value={props.value}
      values={props.values}
      onChange={handleChange}
    />
  ) : (
    <View className={clsx(props.className)} mode='view' value={props.value} />
  );
};
